import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { GlobalService } from '../../services/global.service';
import { PaymentCodeClassificationResponseDto, UpdatePaymentCode, PaymentCodeClassification, PaymentCodeView } from '../../models/paymentCode'; 
import { ConstraintsModel, GridColumnHeader} from '../../models/grid-column-header';
import { paymentCodeInfoHeaders} from '../../common/staticGridColumnHeader';
import { VendorClassLookupRequest, VendorClassLookupResponseDto } from '../../models/vendorDetailsDtos';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-code',
  templateUrl: './payment-code.component.html',
  styleUrl: './payment-code.component.scss',
})
export class PaymentCodeComponent implements OnInit {
  isDataAvailable: boolean= true;
  columns: GridColumnHeader[] =  paymentCodeInfoHeaders;
  paymentCodeClassificationsResponse!: PaymentCodeClassificationResponseDto;
  paymentClassification: PaymentCodeView[] = []; 
  selectedPaymentCodeClassification: PaymentCodeView| null = null;
  isTableLoading: boolean = true;
  sortField: string="";
  sortOrder: number = 1; // 1 for ascending, -1 for descending
  editingPaymentInfoRows: { [index: number]: boolean } = {};
  totalRecords: number = 0;
  clonedRows: { [index: number]: PaymentCodeClassification } = {}; 
  isAnyRowBeingEdited: boolean = false;
  isNewRowBeingEdited: boolean = false;
  isDeleteMode: boolean = false;
  pageNumber: number = 0;
  rowsOptions = [ 
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '75', value: 75 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
    { label: '300', value: 300 },
    { label: '500', value: 500 },
  ];
  rows: number = 25;
  dragSelecting = false;
  selectedIndexes: number[] = [];
  pagesToHoldData: number = 0;
  // Filtering
  filters: { [key: string]: any } = {};
  data: PaymentCodeClassification[] = []; 
  validationTouched: boolean[] = [];
  companyCodeValues: { companycode: string }[] = [];
  filteredVendors: any[] = [];
  selectedVendors: any[] = [];
  constructor (
    private readonly commonService: CommonService,
    private readonly globalVariable: GlobalService, 
    private readonly router: Router
  ){ }

  ngOnInit(): void { 
    //Hide Payment Code tab for IBERIA, NORTH WEST EUROPE systems
    if (['6001'].includes(this.globalVariable.getSelectedSystemId)) {
      this.router.navigate(['']);
    }
    this.commonService.clearMessage();
    this.loadData();
    this.getCompanyCode();
  }

  onRowsChange(event: Event) {
    this.selectedIndexes = [];
    this.syncSelectedWorkItems();
    const target = event.target as HTMLSelectElement;
    const selectedValue = Number(target.value);
    this.rows = selectedValue === 0 ? this.paymentClassification.length : selectedValue;
  } 

  saveRow(index: number) {
    const row = this.paymentClassification[index];
    if (!this.validateRow(row)) {
      this.isAnyRowBeingEdited = true;
      this.validationTouched[index] = true;
      return;
    } 
    delete this.editingPaymentInfoRows[index];
    this.savePaymentDetailsDetails(row);
    this.isAnyRowBeingEdited = false;
  }

  validateRow(row: PaymentCodeClassification): boolean {
    const rowIndex = this.paymentClassification.findIndex(r => r === row);
    const original = this.clonedRows[rowIndex];
    const isvendorERPIDValid = (!!row.vendorERPID && this.selectedVendors[rowIndex]) || row.vendorERPID === original?.vendorERPID;
    // Vendor ERP Id must be selected from the list (selectedVendors)
    return isvendorERPIDValid && !!row.system && !!row.companyCode && !!row.country && !!row.name && !!row.paymentCode && !!row.paymentMethod;
  }
  
  addNewRow() {
    if (this.isAnyRowBeingEdited) return;
    const newRow: PaymentCodeView = {
      system: this.globalVariable.getSelectedSystemId,
      companyCode: "",
      country: "",
      name: "",
      paymentCode: null!,
      paymentMethod: "",
      vendorERPID: "",
      isNew: true,
      id: null!,
      systemId: 0
    };
      this.paymentClassification.unshift(newRow);
      this.editingPaymentInfoRows[0] = true;
      this.isAnyRowBeingEdited = true;
      this.isNewRowBeingEdited = true;
  }

  searchData(): void {
    this.paymentClassification = [];
    this.data = [];
    this.totalRecords = 0;
    this.paymentCodeClassificationsResponse.currentPage = 0;
    this.loadData();
  }

  savePaymentDetailsDetails(PaymentCodeDetails: PaymentCodeClassification): void {
    const payload: UpdatePaymentCode = {
      CompanyCode: PaymentCodeDetails.companyCode,
      Country: PaymentCodeDetails.country,
      PaymentCode: PaymentCodeDetails.paymentCode,
      SystemId: Number(this.globalVariable.getSelectedSystemId),
      VendorERPID: PaymentCodeDetails.vendorERPID,
      Name: PaymentCodeDetails.name,
      PaymentMethod: PaymentCodeDetails.paymentMethod,
      UserGpid:this.globalVariable.getUserGPID,
      IsDelete:false
    };
    this.commonService.savePaymentCode(payload).subscribe({
      next: (response) => {
        this.commonService.showMessage("Saved PaymentCode Info.", 'success');
        if (this.isNewRowBeingEdited) {
          this.searchData();
          this.isAnyRowBeingEdited = false;
        }
      },
      error: (error) => {
        this.commonService.showMessage(error.error.message, 'error');
      }
    });
  }

  cancelSave(index?: any): void {
    const row = this.paymentClassification[index];
    if (row.isNew) {
      this.paymentClassification.splice(index, 1);
      // Update clone and editing status
      delete this.clonedRows[index];
      delete this.editingPaymentInfoRows[index];
      this.isAnyRowBeingEdited = false;
      this.isNewRowBeingEdited = false;
      return;
    }
    if (this.clonedRows[index]) {
      this.paymentClassification[index] = { ...this.clonedRows[index] };
      delete this.clonedRows[index];
    }
    delete this.editingPaymentInfoRows[index];
    this.isAnyRowBeingEdited = false;
    this.isNewRowBeingEdited = false;
  }
  
  editRow(index: number) {
    if (this.isAnyRowBeingEdited) return; 
    this.clonedRows[index] = { ...this.paymentClassification[index] };
    this.editingPaymentInfoRows[index] = true;
    this.isAnyRowBeingEdited = true; 
  }

  onCheckboxClick(index: number) {
    const selectedItem = this.paymentClassification[index];
    if (this.selectedPaymentCodeClassification?.id === selectedItem.id) {
      this.selectedPaymentCodeClassification = null; // Deselect
    } else {
      this.selectedPaymentCodeClassification = selectedItem; // Select new
    }
    this.syncSelectedWorkItems();
  }

  deleteRow(index: number) {
    if (this.isAnyRowBeingEdited || !this.selectedPaymentCodeClassification) return;
    this.isAnyRowBeingEdited = true;
    const payload: UpdatePaymentCode = {
    CompanyCode: this.selectedPaymentCodeClassification.companyCode,
    Country: this.selectedPaymentCodeClassification.country,
    PaymentCode: this.selectedPaymentCodeClassification.paymentCode,
    Name: this.selectedPaymentCodeClassification.name,
    PaymentMethod: this.selectedPaymentCodeClassification.paymentMethod,
    SystemId: Number(this.globalVariable.getSelectedSystemId),
    VendorERPID: this.selectedPaymentCodeClassification.vendorERPID,
    UserGpid:this.globalVariable.getUserGPID,
    IsDelete:true
    };
    this.commonService.deletePaymentCode(payload).subscribe({
      next: (response) => {
        this.isAnyRowBeingEdited = false;
        this.searchData();
        this.isDeleteMode = false;
        this.commonService.showMessage("Deleted Successfully.", 'success');
      },
      error: (error) => {
        this.isAnyRowBeingEdited = false;
        this.commonService.showMessage(error.error.message, 'error');
      }
    });
  }

  onPageChange(event: any) {
    const currentPage = Math.ceil(event.first / event.rows) + 1;
    const rowsPerPage = event.rows;
    const totalPages = Math.ceil(this.totalRecords / rowsPerPage); 
    const isLastPage = (currentPage === totalPages - 1) || (currentPage === totalPages);
    if (isLastPage) {
      this.pagesToHoldData = event.first;
      this.paymentCodeClassificationsResponse.currentPage = this.paymentCodeClassificationsResponse.currentPage + 1;
      if (this.paymentCodeClassificationsResponse.hasMoreItems) { 
        this.loadData();
      }
    }
  }

  loadData(): void {
    this.isTableLoading = true;
    let pageNo = 0;
    if(this.paymentCodeClassificationsResponse?.currentPage){
      pageNo = this.paymentCodeClassificationsResponse.currentPage;
    }
    this.commonService.getPaymentCodes(this.globalVariable.getUserGPID,this.globalVariable.getSelectedSystemId,pageNo).subscribe({
      next: (response) => {
        this.isDataAvailable = response.results.length > 0 ? true : false;
        this.paymentCodeClassificationsResponse = response;
        this.totalRecords = (this.totalRecords == 0 && pageNo != 0) ? response.rowCount : this.totalRecords + response.rowCount;
        const dataWorkItems = response.results?.map((paymentClassification: PaymentCodeClassification) => ({
          ...paymentClassification,
          isNew: false
        }));
        this.paymentClassification = this.totalRecords == 0 ? dataWorkItems :
          [...this.paymentClassification, ...response.results?.map((vi: any) => ({
            ...vi,
            isNew: false
          }))];
          this.data = this.paymentClassification;
        this.generateFilters();
        this.customFilter();
        this.isTableLoading = false;
        setTimeout(() => {
          if (pageNo > 0) {
            this.pageNumber = this.pagesToHoldData;
          }
        }, 0);
      },
      error: (error) => {
        this.isDataAvailable = false;
        this.isTableLoading = true;
      }
    });
  }

  generateFilters() {
    this.columns.forEach(column => {
      if (column.type == 'date') {
        column.filterOptions = [
          { label: 'Past 7 days', value: '7' },
          { label: 'Past 14 days', value: '14' },
          { label: 'Past 1 month', value: '30' },
          { label: 'Past 2 months', value: '60' },
          { label: 'Past 3 months', value: '90' },
          { label: 'Past 6 months', value: '182' },
          { label: 'Last year', value: '365' },
          { label: 'All', value: 'All' }
        ];
        column.selectedValues = [];
      } else {
        const values = new Set<string | boolean | number>();
        this.data.forEach(record => {
          const propertyName: keyof PaymentCodeClassification = column.field as keyof PaymentCodeClassification;
          values.add(record[propertyName]);
        });
        column.filterOptions = Array.from(values).map(v => ({ label: v.toString(), value: v.toString() }));
        column.selectedValues = [];
      }
    });
  }

  customClear(col: GridColumnHeader) {
    if(col.advancefilter.isAdvanceFilterUsed){
      this.clearCall(col);
    }
    this.filters[col.field] = [];
    this.customFilter(col.field);
  }
 
  isSelected( index: number): boolean {
    return this.selectedIndexes.includes(index);
  }

  onRowClick(event: MouseEvent, index: number): void {
    this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
  }

  toggleRowSelection(index: number, ctrlKey: boolean, shiftKey: boolean): void {
    if (!ctrlKey && !shiftKey) { 
      this.selectedIndexes = [index];
    }
    else{
      const alreadySelected = this.selectedIndexes.includes(index);
      if (!alreadySelected) {
        this.selectedIndexes.push(index);
      }
      else {
        this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
      }
    } 
    this.syncSelectedWorkItems();
  }

  onMouseDown(event: MouseEvent, index: number) { 
    const ctrlKey = event.ctrlKey || event.metaKey;
    const shiftKey = event.shiftKey;
    if (event.button === 0 && !ctrlKey && !shiftKey) { 
      this.dragSelecting = true;
      this.selectedIndexes = [index];
      this.syncSelectedWorkItems();
      event.preventDefault();
    } 
  }

  onMouseOver(event: MouseEvent, index: number) {
    if (event.button === 0 && this.dragSelecting && !this.selectedIndexes.includes(index)) {
      this.selectedIndexes.push(index);
      this.syncSelectedWorkItems();
    }
  }

  onMouseUp() {
    if (this.dragSelecting) {
      this.dragSelecting = false; 
    } 
  }

  onRowKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleRowSelection(index, event.ctrlKey || event.metaKey, event.shiftKey);
    }
  }

  onRowFocus(_event: FocusEvent, _index: number): void {
  }

  syncSelectedWorkItems() {
    const validIndex = this.selectedIndexes.find(i => i >= 0 && i < this.paymentClassification.length);
    this.selectedPaymentCodeClassification = validIndex !== undefined
      ? this.paymentClassification[validIndex]
      : null;
  }
   
  customFilter(value?: any){
    this.selectedIndexes=[];
    this.syncSelectedWorkItems();
    let filteredData = [...this.data];
    if (Object.keys(this.filters).length) {
      Object.keys(this.filters).forEach((field) => {
        const selectedValues = this.filters[field];
        if (!selectedValues || selectedValues.length === 0)
          return;
        const propertyName: keyof PaymentCodeClassification = field as keyof PaymentCodeClassification;
        filteredData = filteredData.filter((workItem) => selectedValues.includes(workItem[propertyName]));
      });
    }
    this.paymentClassification = filteredData; 
  } 

  getCompanyCode() {
    const payload: VendorClassLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "COMPANYCODE",
      lookupFieldValue: "",
    };

    this.commonService.getVendorClassAutoComboValueLookup<{ companycode: string }>(payload).subscribe({
      next: (response: { companycode: string }[]) => {
        this.companyCodeValues = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Company Code values: ' + err.error.message, 'error');
      }
    });
  }

  searchVendors(event: any, field: string) {
    if (!event || typeof event.query !== 'string') {
      return;
    }

    const value = event.query;
    const payload: VendorClassLookupRequest = {
      userGpid: this.globalVariable.getUserGPID,
      systemId: Number(this.globalVariable.getSelectedSystemId),
      lookupFieldName: "VENDORERPID",
      lookupFieldValue: value,
    };

    this.commonService.getVendorClassAutoComboValueLookup<VendorClassLookupResponseDto>(payload).subscribe({
      next: (response: VendorClassLookupResponseDto[]) => {
        this.filteredVendors = response;
      },
      error: (err) => {
        this.commonService.showMessage('Error loading Vendor ERP Id values: ' + err.error.message, 'error');
      }
    });
  }

  onVendorSelect(event: any, rowData: any, rowIndex: number) {
    const selected = event.value as VendorClassLookupResponseDto;
    this.selectedVendors[rowIndex] = selected;
    rowData['vendorERPID'] = selected.vendorERPID.trim();
    rowData['name'] = selected.vendorname.trim();
  }

  onVendorInputChange(value: string, rowIndex: number) {
    if (!value || !this.selectedVendors[rowIndex] || this.selectedVendors[rowIndex].vendorerpid !== value) {
      this.selectedVendors[rowIndex] = '';
    }
  }

  applyCall(col:GridColumnHeader, filterRef: any){
    col.advancefilter.isAdvanceFilterUsed = true;
    this.applyAdvancedFilter(col);
    filterRef.hide();
  }

  applyAdvancedFilter(col: GridColumnHeader) {
    const field = col.field;
    const filterMeta = col.advancefilter; 
    // Skip filtering if no constraints or filter not enabled
    if (!filterMeta?.isAdvanceFilterUsed || !filterMeta.constraints?.length) {
      return;
    } 
    const constraints = filterMeta.constraints;
    const lastConstraint = constraints[constraints.length - 1]; 
    const operator = !lastConstraint || lastConstraint.value === null || lastConstraint.value === ''
                      ? 'or' : filterMeta.operator || 'or';
    this.paymentClassification = this.paymentClassification.filter(row => {
        const rowValue = (row as any)[field]; 
        const results = constraints.map(constraint => {
          const filterValue = constraint.value;
          const matchMode = constraint.matchMode; 
          const stringValue = rowValue?.toString()?.toLowerCase?.();
          const filterString = filterValue?.toString()?.toLowerCase?.(); 
          switch (matchMode) { 
            case 'eq':
              return stringValue === filterString;
            case 'startswith':
              return stringValue?.startsWith(filterString);
            case 'contains':
              return stringValue?.includes(filterString);
            case 'doesnotcontain':
              return !stringValue?.includes(filterString);
            case 'endswith':
              return stringValue?.endsWith(filterString); 
            case 'gt':
              return new Date(rowValue) > new Date(filterValue);
            case 'gte':
              return new Date(rowValue) >= new Date(filterValue);
            case 'lt':
              return new Date(rowValue) < new Date(filterValue);
            case 'lte':
              return new Date(rowValue) <= new Date(filterValue); 
            case 'isnull':
              return rowValue == null || rowValue === '';
            case 'isnotnull':
              return rowValue != null && rowValue !== ''; 
            default:
              return true;
          }
        });
        // Combine with AND/OR operator
        return operator === 'or' ? results.some(r => r) : results.every(r => r);
    });
  }
 
  clearCall(col: GridColumnHeader, filterCallback?: any, filterRef?: any) {
    col.advancefilter.isAdvanceFilterUsed = false;
    col.advancefilter.constraints.forEach((c:ConstraintsModel) => {
      c.value = '';
    });
    this.paymentClassification = this.data;
    if(filterCallback && filterRef){
      filterCallback(null);filterRef.hide();
    }
  }

  onDateRuleChange(event: any, field: string, index: number) {
    const value = event ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onRuleChange(event: any, field: string, index: number) {
    const value = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].value = value;
    }
  }

  onMatchModeChange(event: any, field: string, index: number) {
    const mode = typeof event === 'string' ? event : event.target?.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.constraints[index].matchMode = mode;
    }
  }

  onOperatorChange(event: any, field: string) {
    const operator = typeof event === 'string' ? event : event.value;
    const col = this.columns.find(c => c.field === field);
    if (col) {
      col.advancefilter.operator = operator;
    }
  }
}
